export enum OperatorGuardPlayerStatus {
  ACTIVE = 'ACTIVE',
  PENDING_LONG_SESSION = 'PENDING_LONG_SESSION',
  UNDEFINED = 'UNDEFINED'
}
